"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseArticleStyled = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseArticleStyled = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background: ", ";\n\n  ", "\n"], ["\n  width: 100%;\n  background: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.grey005;
}, function (_a) {
    var roundedBorder = _a.roundedBorder;
    return roundedBorder && 'border-top-left-radius: 24px;';
});
var templateObject_1;
